import React, { useEffect } from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import Header from '../header/header';
import Footer from '../footer/Footer';

const EthicsBlog = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="App-main">
            <Header />
            <Container maxWidth="md" sx={{ py: 8 }}>
                <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, borderRadius: 4 }}>
                    <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 800, color: '#1a202c' }}>
                        Our Commitment to Ethics at ConvoCue AI
                    </Typography>
                    
                    <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', color: '#4a5568', textAlign: 'left' }}>
                        At ConvoCue AI, we recognize our role and responsibility in shaping the future of AI-driven interview preparation and enhancement. Our commitment to ethical practices is at the core of everything we do, ensuring that our technology not only advances professional growth but also safeguards the values we hold dear.
                    </Typography>

                    <Box sx={{ mb: 6, textAlign: 'left' }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
                            Empowering Through Knowledge
                        </Typography>
                        <Typography variant="body1" paragraph>
                            ConvoCue AI is dedicated to educating the community about the possibilities and advancements within Interview AI technologies. Our platform is designed to be more than just a tool for interview preparation; it's a means to empower individuals by enhancing their communication skills. 
                        </Typography>
                        <Typography variant="body1" paragraph>
                            We aim to provide individuals from all backgrounds—including those seeking to align their vocal presentation with their identity or those overcoming communication barriers—with the tools they need to present their best selves without the need for extensive training or medical procedures.
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 4 }} />

                    <Box sx={{ mb: 6, textAlign: 'left' }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
                            Safeguarding Against Misuse
                        </Typography>
                        <Typography variant="body1" paragraph>
                            We are aware of the potential for misuse of advanced AI technologies. ConvoCue AI implements stringent measures, including the use of sophisticated algorithms capable of detecting and preventing the unethical use of our technology. 
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Our goal is to maintain the integrity and trustworthiness of the interactions facilitated by our platform, ensuring they remain genuine, respectful, and free from exploitation. We believe AI should be a tool for growth and preparation, not a substitute for authentic human connection.
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 6, textAlign: 'left' }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
                            Our Pledge
                        </Typography>
                        <Typography variant="body1" component="div">
                            <ul>
                                <li><strong>Advance with Care:</strong> Continue developing our technology with a keen focus on ethical considerations, prioritizing the welfare and dignity of our users.</li>
                                <li><strong>Engage and Listen:</strong> Actively engage with our community, listen to their concerns, and adapt our practices to reflect our collective ethical standards.</li>
                                <li><strong>Transparency:</strong> Maintain openness about our technology's capabilities and limitations, fostering an environment of trust and reliability.</li>
                            </ul>
                        </Typography>
                    </Box>

                    <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 4, color: '#718096', textAlign: 'left' }}>
                        At ConvoCue AI, we're committed to a future where AI enhances human potential without compromising our ethical values. We invite our users, partners, and the wider community to join us in this journey, ensuring that the evolution of AI in interview and communication enhancement serves the greater good.
                    </Typography>
                </Paper>
            </Container>
            <Footer theme="light" />
        </div>
    );
};

export default EthicsBlog;
